import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';

const initializeSwiperHome = () => {
    // Inicializa o Swiper
    const swiper = new Swiper('.swiper-container', {
        effect: "fade",
        fadeEffect: {
            crossFade: true
        },
        loop: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        speed: 500, // Aumenta a suavidade da transição entre as imagens
        effect: 'fade', // Usar efeito fade para transição
    });

    // Seletor dos botões de navegação
    const buttons = document.querySelectorAll(".banner-btn");

    // Verifica se há uma categoria ativa via URL
    const urlParams = new URLSearchParams(window.location.search);
    const categoriaAtiva = urlParams.get("categoria");

    // Define o slide ativo conforme a URL, se existir
    buttons.forEach((button, index) => {
        if (button.dataset.categoria === categoriaAtiva) {
            swiper.slideTo(index);
            buttons.forEach(btn => btn.classList.remove("ativo"));
            button.classList.add("ativo");
        }
    });

    // Evento de clique nos botões de navegação
    buttons.forEach((button, index) => {
        button.addEventListener("click", () => {
            swiper.slideTo(index); // Troca para o slide correspondente ao botão clicado

            // Remove a classe ativo de todas as categorias
            buttons.forEach(btn => btn.classList.remove("ativo"));
            
            // Adiciona a classe ativo ao botão clicado
            button.classList.add("ativo");

            // Atualiza a URL sem recarregar a página
            const categoriaSelecionada = button.dataset.categoria;
            const newUrl = new URL(window.location);
            newUrl.searchParams.set("categoria", categoriaSelecionada);
            window.history.pushState({}, "", newUrl);
        });
    });

    // Atualiza a categoria ativa ao mudar de slide
    swiper.on('slideChange', () => {
        const activeIndex = swiper.realIndex;
        const activeCategoria = document.querySelector(`.swiper-slide:nth-child(${activeIndex + 1})`).dataset.categoria;
        
        buttons.forEach(button => {
            button.classList.remove("ativo");
            if (button.dataset.categoria === activeCategoria) {
                button.classList.add("ativo");

                // Atualiza a URL sem recarregar a página
                const newUrl = new URL(window.location);
                newUrl.searchParams.set("categoria", activeCategoria);
                window.history.pushState({}, "", newUrl);
            }
        });
    });
};

export default initializeSwiperHome;
